import { RouteConfig } from 'app/router/Routes'
import NotFound from './NotFound'

export const NOT_FOUND_PATH = '/session/404'

const settings = {
  activeLayout: 'layout1',
  layout1Settings: {
    topbar: {
      show: false
    },
    leftSidebar: {
      show: false,
      mode: 'close'
    }
  },
  layout2Settings: {
    mode: 'full',
    topbar: {
      show: false
    },
    navbar: { show: false }
  },
  secondarySidebar: { show: false },
  footer: { show: false }
}

const sessionRoutes: RouteConfig[] = [
  {
    path: NOT_FOUND_PATH,
    component: NotFound,
    settings
  }
]

export default sessionRoutes
